import React from 'react';
import { Banner } from './MessageStatusBanner.styled';
import { MessageStatus } from '../../../constants/streamingConstants';

const LABELS = {
  [MessageStatus.FAILED]: 'Response failed',
  [MessageStatus.INCOMPLETE]: 'Response incomplete',
  [MessageStatus.CANCELLED]: 'Response cancelled',
};

/**
 * MessageStatusBanner - FAILED (red), INCOMPLETE (amber), CANCELLED (gray) banners.
 */
const MessageStatusBanner = ({ status }) => {
  if (!status) return null;

  const label = LABELS[status] ?? 'Response error';

  return (
    <Banner $status={status} role="status">
      {label}
    </Banner>
  );
};

export default MessageStatusBanner;
